/* Nélya Paris — câblage de la page. La logique testable est dans nelya-core.js. */
(function () {
  'use strict';
  var C = window.NelyaCore;
  var root = document.documentElement;
  var isProduct = document.body.classList.contains('template-product');

  function readVariants() {
    var el = document.getElementById('nelya-variants');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }
  var variants = readVariants();

  /* Nom affiché d'une teinte (traduit dans les locales) ; la valeur interne reste « Brun » ou « Gris ». */
  function shadeName(t) {
    var s = window.nelyaShop && window.nelyaShop.shades;
    return (s && s[t]) || t;
  }

  /* Teinte : une seule valeur pour toute la page (visuels, cartes, libellés, formulaire, URL du produit). */
  function setTeinte(v, opts) {
    var t = C.normalizeTeinte(v);
    if (!t) return;
    root.setAttribute('data-teinte', t);
    document.querySelectorAll('input[data-teinte]').forEach(function (i) { i.checked = i.value === t; });
    document.querySelectorAll('[data-shade-name]').forEach(function (n) { n.textContent = shadeName(t); });
    document.querySelectorAll('.shade-img[data-for]').forEach(function (im) {
      if (im.getAttribute('data-for') === t) im.removeAttribute('aria-hidden'); else im.setAttribute('aria-hidden', 'true');
    });
    var variant = C.variantForTeinte(variants, t);
    if (!variant) return;
    // Chaque formulaire porte ses propres variantes (data-variant-brun / data-variant-gris).
    document.querySelectorAll('form.js-product-form').forEach(function (f) {
      var id = f.getAttribute('data-variant-' + t.toLowerCase());
      var input = f.querySelector('[data-variant-input]');
      if (id && input) input.value = id;
    });
    document.dispatchEvent(new CustomEvent('nelya:teinte', { detail: { teinte: t, variant: variant } }));
    // Avec les lots, la variante de l'adresse est celle du lot (posée par initLots, qui écoute « nelya:teinte »).
    if (isProduct && !document.querySelector('[data-lots]') && !(opts && opts.silent) && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }
  window.nelyaSetTeinte = setTeinte;

  /* Images différées (mannequin de l'autre teinte en couverture) : chargées après la page ou au choix de la teinte. */
  function loadDeferred() {
    document.querySelectorAll('img[data-deferred-src]').forEach(function (im) {
      if (im.hasAttribute('data-deferred-srcset')) im.setAttribute('srcset', im.getAttribute('data-deferred-srcset'));
      im.setAttribute('src', im.getAttribute('data-deferred-src'));
      im.removeAttribute('data-deferred-src'); im.removeAttribute('data-deferred-srcset');
    });
  }
  if (document.readyState === 'complete') setTimeout(loadDeferred, 1500);
  else window.addEventListener('load', function () { setTimeout(loadDeferred, 1500); });

  function initTeinte() {
    document.querySelectorAll('input[data-teinte]').forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) setTeinte(i.value); });
    });
    var variantId = isProduct ? new URL(window.location.href).searchParams.get('variant') : null;
    setTeinte(C.initialTeinte({ variantId: variantId, variants: variants }), { silent: true });
  }

  /* Lots : un lot = une variante avec son propre prix (une par nuance, une seule pour le Duo). Le choix d'un lot ou
     d'une nuance met cette variante dans le champ name="id" du formulaire produit, la quantité reste 1, et rien n'est
     recalculé : Releasit lit ce champ (premier formulaire /cart/add de la page) et se met à jour sur l'événement
     « change » et sur history.replaceState. Le Duo masque le choix de nuance. */
  function initLots() {
    var box = document.querySelector('[data-lots]');
    var form = document.getElementById('product-form-main');
    if (!box || !form) return;
    var radios = [].slice.call(box.querySelectorAll('input[data-lot]'));
    var idInput = form.querySelector('[data-variant-input]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var pdp = box.closest('.pdp');
    if (!radios.length || !idInput) return;
    function byId(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }
    function apply(opts) {
      var r = radios.filter(function (x) { return x.checked; })[0] || radios[0];
      r.checked = true;
      var duo = r.hasAttribute('data-duo');
      var brun = root.getAttribute('data-teinte') === 'Brun';
      var v = byId(duo ? r.getAttribute('data-variant') : r.getAttribute(brun ? 'data-variant-brun' : 'data-variant-gris'))
        || byId(r.getAttribute(brun ? 'data-variant-gris' : 'data-variant-brun'));
      if (pdp) pdp.classList.toggle('pdp--duo', duo);
      if (!v) return;
      if (qtyInput) qtyInput.value = 1;
      if (String(idInput.value) !== String(v.id)) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var save = v.compare > v.price ? v.compare - v.price : 0;
      document.querySelectorAll('[data-unit-price]').forEach(function (el) { el.textContent = C.formatMoney(v.price); });
      document.querySelectorAll('[data-total]').forEach(function (el) { el.textContent = C.formatMoney(v.price); });
      document.querySelectorAll('[data-compare]').forEach(function (el) { el.hidden = !save; });
      document.querySelectorAll('[data-compare-amount]').forEach(function (el) { el.textContent = C.formatMoney(v.compare); });
      document.querySelectorAll('[data-save]').forEach(function (el) { el.hidden = !save; });
      document.querySelectorAll('[data-save-amount]').forEach(function (el) { el.textContent = C.formatMoney(save); });
      if (isProduct && !(opts && opts.silent) && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { apply(); }); });
    document.addEventListener('nelya:teinte', function () { apply(); });
    apply({ silent: true });
  }

  /* Bouton Releasit sous les lots : l'app pose fond, couleur et arrondi en style en ligne « !important », qu'aucune
     feuille de style ne peut remplacer. On les remplace dans le même style en ligne, à l'insertion du bouton et chaque
     fois que l'app le redessine. */
  var COD_STYLE = { background: '#512C23', color: '#F0EBD5', 'border-radius': '999px', 'box-shadow': 'none' };
  function initCodButton() {
    var zone = document.querySelector('.pdp__cod');
    if (!zone || !('MutationObserver' in window)) return;
    // Valeurs telles que le navigateur les relit (#512C23 → rgb(81, 44, 35)) : on n'écrit que si elles diffèrent, sinon
    // chaque écriture relancerait l'observateur.
    var norm = {}, probe = document.createElement('i').style;
    Object.keys(COD_STYLE).forEach(function (k) { probe.setProperty(k, COD_STYLE[k]); norm[k] = probe.getPropertyValue(k); });
    function paint() {
      zone.querySelectorAll('._rsi-buy-now-button').forEach(function (b) {
        Object.keys(COD_STYLE).forEach(function (k) {
          if (b.style.getPropertyValue(k) !== norm[k] || b.style.getPropertyPriority(k) !== 'important') b.style.setProperty(k, COD_STYLE[k], 'important');
        });
        b.querySelectorAll('svg[fill]').forEach(function (svg) { if (svg.getAttribute('fill') !== COD_STYLE.color) svg.setAttribute('fill', COD_STYLE.color); });
      });
    }
    new MutationObserver(paint).observe(zone, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'fill'] });
    paint();
  }

  /* Liens vers la page produit (section « Le coffret » de l'accueil) : ils suivent la teinte choisie (?variant=).
     Le thème n'ajoute jamais rien au panier : l'achat se fait par le formulaire Releasit de la page produit. */
  function initProductLinks() {
    document.addEventListener('nelya:teinte', function (e) {
      document.querySelectorAll('[data-product-link]').forEach(function (a) {
        var box = a.closest('[data-variant-brun]');
        var id = box && box.getAttribute('data-variant-' + e.detail.teinte.toLowerCase());
        if (!id) return;
        var url = new URL(a.href, window.location.href);
        url.searchParams.set('variant', id);
        a.href = url.pathname + url.search + url.hash;
      });
    });
  }

  /* Avis : flèches du carrousel. */
  function initUgc() {
    var l = document.getElementById('ugc');
    if (!l) return;
    document.querySelectorAll('[data-ugc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = l.querySelector('.ugc__card');
        var w = c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(l).columnGap || 0) : 320;
        l.scrollBy({ left: (b.getAttribute('data-ugc') === 'next' ? 1 : -1) * w, behavior: 'smooth' });
      });
    });
  }

  /* Menu mobile (burger) : ouvre/ferme la liste, Échap ferme et rend le focus. */
  function initBurger() {
    var header = document.querySelector('[data-header]');
    var btn = header && header.querySelector('[data-burger]');
    if (!btn) return;
    function set(open) {
      header.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(open ? 'data-label-close' : 'data-label-open'));
    }
    btn.setAttribute('data-label-open', btn.getAttribute('aria-label'));
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { set(false); btn.focus(); }
    });
    header.querySelectorAll('.r3-links a').forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
  }

  /* Aide teinte : la réponse choisit la teinte et affiche le conseil. Échap la referme. Quand elle s'ouvre en panneau
     par-dessus les cartes (ordinateur, voir nelya-product.css), un clic en dehors ou le clavier qui la quitte la referme aussi. */
  function initHelper() {
    var helper = document.querySelector('details.helper');
    var out = document.querySelector('.helper__out');
    if (helper) {
      var panel = helper.querySelector('.helper__in');
      var floating = function () { return getComputedStyle(panel).position === 'absolute'; };
      document.addEventListener('click', function (e) { if (helper.open && !helper.contains(e.target) && floating()) helper.open = false; });
      document.addEventListener('keydown', function (e) {
        var f = document.activeElement;
        if (e.key !== 'Escape' || !helper.open || (f && f !== document.body && !helper.contains(f))) return;
        helper.open = false; helper.querySelector('summary').focus();
      });
      helper.addEventListener('focusout', function (e) {
        if (helper.open && e.relatedTarget && !helper.contains(e.relatedTarget) && floating()) helper.open = false;
      });
    }
    document.querySelectorAll('[data-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-pick');
        setTeinte(v);
        document.querySelectorAll('[data-pick]').forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
        if (out) { out.hidden = false; out.querySelector('[data-reco]').textContent = shadeName(v); }
      });
    });
  }

  /* Galerie : piste à défilement (glisser au doigt), miniatures, flèches, clavier, compteur, points.
     Seules les diapositives communes et celles de la teinte choisie sont montrées. */
  function initGallery() {
    var t = document.getElementById('g-track');
    if (!t) return;
    var all = [].slice.call(t.children);
    var thumbs = [].slice.call(document.querySelectorAll('.gallery__thumbs li'));
    var dots = [].slice.call(document.querySelectorAll('.gallery__dots i'));
    var n = document.getElementById('g-n'), total = document.getElementById('g-total');
    var visible = [], cur = -1, raf;
    function mark(i) {
      if (i === cur) return;
      cur = i; n.textContent = i + 1;
      visible.forEach(function (k, j) {
        thumbs[k].querySelector('button').setAttribute('aria-current', j === i ? 'true' : 'false');
        dots[k].classList.toggle('on', j === i);
      });
    }
    function filter(teinte) {
      visible = C.visibleSlides(all.map(function (s) { return s.getAttribute('data-slide-for') || ''; }), teinte);
      all.forEach(function (s, k) {
        var on = visible.indexOf(k) !== -1;
        s.hidden = !on; thumbs[k].hidden = !on; dots[k].hidden = !on;
      });
      total.textContent = visible.length;
      cur = -1; mark(Math.min(C.galleryIndex(t.scrollLeft, t.clientWidth, visible.length), visible.length - 1));
    }
    function go(i) {
      i = Math.max(0, Math.min(visible.length - 1, i));
      t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' });
    }
    t.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(C.galleryIndex(t.scrollLeft, t.clientWidth, visible.length)); });
    }, { passive: true });
    thumbs.forEach(function (li, k) {
      li.querySelector('button').addEventListener('click', function () { go(visible.indexOf(k)); });
    });
    document.querySelectorAll('[data-g]').forEach(function (b) {
      b.addEventListener('click', function () { go(cur + (b.getAttribute('data-g') === 'next' ? 1 : -1)); });
    });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    document.addEventListener('nelya:teinte', function (e) { filter(e.detail.teinte); });
    filter(root.getAttribute('data-teinte'));
  }

  /* Quantité : bornée de 1 à 10, total affiché sur les boutons d'achat. */
  function initQty() {
    var o = document.getElementById('qty');
    var input = document.querySelector('[data-qty-input]');
    var unitEl = document.querySelector('[data-unit]');
    if (!o || !input || !unitEl) return;
    var unit = Number(unitEl.getAttribute('data-unit'));
    input.value = 1; o.textContent = 1;
    function render() {
      var q = Number(input.value);
      document.querySelectorAll('[data-total]').forEach(function (el) { el.textContent = C.formatMoney(unit * q); });
      document.querySelectorAll('[data-unit-price]').forEach(function (el) { el.textContent = C.formatMoney(unit); });
    }
    document.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = C.clampQty(Number(input.value) + parseInt(b.getAttribute('data-q'), 10));
        input.value = q; o.textContent = q;
        render();
      });
    });
    document.addEventListener('nelya:teinte', function (e) { unit = e.detail.variant.price; render(); });
  }

  /* Barre d'achat collante : visible tant que le bouton principal n'est pas entièrement à l'écran (passé au-dessus, ou
     encore en dessous quand les lots le repoussent sous la ligne de flottaison). */
  function initStickybuy() {
    var a = document.getElementById('addrow'), s = document.getElementById('stickybuy');
    if (!a || !s) return;
    var btn = s.querySelector('a, button'), last = null;
    function set(on) {
      if (on === last) return;
      last = on;
      s.classList.toggle('is-on', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    }
    // L'observateur suit tout déplacement du bouton : défilement, lots, aide teinte, polices et images chargées après coup.
    // Un bouton non affiché (taille nulle) ne fait pas apparaître la barre.
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      set(e.boundingClientRect.height > 0 && e.intersectionRatio < 0.99);
    }, { threshold: [0, 0.99] }).observe(a);
  }

  initBurger();
  initGallery();
  initQty();
  initProductLinks();
  initTeinte();
  // Après l'initialisation : seul un vrai changement de teinte avance le chargement des images différées.
  document.addEventListener('nelya:teinte', loadDeferred);
  initLots();
  initCodButton();
  initUgc();
  initHelper();
  initStickybuy();
})();
